import React, { useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Grid,
  Paper,
  Stack,
  useTheme,
} from "@mui/material";

export default function EditImproveAnswer({
  selectedItem,
  onSave,
  onCancel,
  permission,
}) {
  const [editedItem, setEditedItem] = useState({ ...selectedItem });
  const [error, setError] = useState(null);
  const theme = useTheme();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedItem({ ...editedItem, [name]: value });
  };

  const handleSave = async () => {
    try {
      await axiosInstance.put(
        `/edit-improve-question/${editedItem.id}`,
        editedItem
      );
      setError("Data has been saved successfully.");
      onSave();
    } catch (error) {
      console.error("Error updating data:", error);
      setError("Error updating data. Please try again.");
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        mb: 4,
        borderRadius: 3,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography variant="h6" fontWeight="bold" gutterBottom color="textPrimary">
        Edit Improve Answer
      </Typography>

      <Grid container spacing={3}>
        {/* User Question */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="User Question"
            multiline
            rows={6}
            name="questions"
            value={editedItem.questions || ""}
            onChange={handleInputChange}
            variant="outlined"
          />
        </Grid>

        {/* Bot Answer */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Bot Answer"
            multiline
            rows={6}
            name="answers"
            value={editedItem.answers || ""}
            onChange={handleInputChange}
            variant="outlined"
          />
        </Grid>

        {/* Improve Your Answer */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Improve Your Answer"
            multiline
            rows={6}
            name="answer_improvement"
            value={editedItem.answer_improvement || ""}
            onChange={handleInputChange}
            variant="outlined"
          />
        </Grid>
      </Grid>

      {permission.canModify && (
        <Box mt={4}>
          <Stack direction="row" spacing={2}>
            <Button variant="contained" color="primary" onClick={handleSave}>
              Save
            </Button>
            <Button variant="outlined" color="secondary" onClick={onCancel}>
              Cancel
            </Button>
          </Stack>
        </Box>
      )}

      {error && (
        <Box mt={3}>
          <Alert severity={error.includes("successfully") ? "success" : "error"}>
            {error}
          </Alert>
        </Box>
      )}
    </Paper>
  );
}
